/**
 * Keeps --announcement-height equal to the pinned ticker's height, so the
 * sticky navbar sits directly under it (see component-sticky-announcement.css).
 * Measured rather than fixed: the ticker is taller on desktop than on a phone,
 * and a wrong figure either hides the navbar's top edge or leaves a gap.
 */
(() => {
  const ticker = document.querySelector('[class^="ai-rolling-board-"]');
  const section = ticker && ticker.closest('.shopify-section');
  if (!section) return;

  const update = () => {
    document.documentElement.style.setProperty(
      '--announcement-height',
      `${Math.round(section.getBoundingClientRect().height)}px`
    );
  };

  update();
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(section);
})();
